import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Stack } from '../Stack';

export const APPBAR_DESKTOP_HEIGHT = 72;
export const APPBAR_MOBILE_HEIGHT = 50;

interface AppbarContainerProps {
    hasRightActions: boolean;
    small?: boolean;
    hasBorder?: boolean;
}

export const AppbarContainer = styled.div<AppbarContainerProps>`
    background: ${getToken('backgroundStaticSunken')};
    padding: 0 ${({ small }) => (small ? getSpacingToken('100') : getSpacingToken('200'))}px;
    height: ${({ small }) => (small ? APPBAR_MOBILE_HEIGHT : APPBAR_DESKTOP_HEIGHT)}px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;

    ${({ hasRightActions }) =>
        hasRightActions &&
        css`
            padding-right: ${getSpacingToken('200')}px;
        `}

    ${({ hasBorder }) =>
        hasBorder &&
        css`
            border-bottom: ${getToken('borderWidth100')}px solid ${getToken('borderStaticSecondary')};
        `}

    > * {
        width: 100%;
    }
`;

export const ActionElementsContainer = styled(Stack)`
    align-items: center;
    align-self: stretch;
    border-left: 1px solid ${getToken('borderStaticSecondary')};
    display: flex;
    padding: ${getSpacingToken('200')}px 0 ${getSpacingToken('200')}px ${getSpacingToken('200')}px;
`;

export const AppbarDivider = styled.div`
    width: 1px;
    height: ${getSpacingToken('200')}px;
    background: ${getToken('borderStaticPrimary')};
`;
